import React from "react";
import { Badge } from "react-bootstrap";
import { KindredPublishStatus } from "../../interfaces";
import { EntityStatus } from "./types";

export const computeStatus = (
  publishedStatus: number,
  fromDate: string | null,
  toDate: string | null,
  suspended?: boolean
): EntityStatus => {
  const now = new Date();
  const start = fromDate ? new Date(fromDate) : null;
  const end = toDate ? new Date(toDate) : null;
  const withinDates = start && end && start <= now && end >= now;
  const futureStart = start && start > now;
  const pastEnd = end && end < now;

  if (
    publishedStatus === KindredPublishStatus.Approved &&
    withinDates &&
    suspended !== true
  )
    return "LIVE";
  if (
    (publishedStatus === KindredPublishStatus.Deactivated ||
      suspended === true) &&
    withinDates
  )
    return "SUSPENDED";
  if (
    publishedStatus === KindredPublishStatus.Approved &&
    suspended !== true &&
    futureStart
  )
    return "SCHEDULED";
  if (publishedStatus === KindredPublishStatus.Approved && pastEnd)
    return "EXPIRED";
  if (
    publishedStatus !== KindredPublishStatus.Approved &&
    publishedStatus !== KindredPublishStatus.Deactivated &&
    suspended !== true &&
    withinDates
  )
    return "PENDING";
  return "GRAVEYARD";
};

export const statusConfig: Record<EntityStatus, { bg: string; text?: string }> =
  {
    LIVE: { bg: "success" },
    PENDING: { bg: "warning", text: "dark" },
    SCHEDULED: { bg: "info" },
    SUSPENDED: { bg: "danger" },
    EXPIRED: { bg: "secondary" },
    GRAVEYARD: { bg: "dark" },
  };

export const entityStatusBadge = (status: EntityStatus) => {
  const cfg = statusConfig[status];
  return (
    <Badge bg={cfg.bg} text={cfg.text as any}>
      {status}
    </Badge>
  );
};

export const statusPriority: Record<EntityStatus, number> = {
  LIVE: 0,
  PENDING: 1,
  SCHEDULED: 2,
  SUSPENDED: 3,
  EXPIRED: 4,
  GRAVEYARD: 5,
};

export type StatusFilter = EntityStatus | "ALL";

export const STATUS_OPTIONS: { value: StatusFilter; label: string }[] = [
  { value: "LIVE", label: "Live" },
  { value: "SCHEDULED", label: "Scheduled" },
  { value: "PENDING", label: "Pending" },
  { value: "SUSPENDED", label: "Suspended" },
  { value: "EXPIRED", label: "Expired" },
  { value: "GRAVEYARD", label: "Graveyard" },
  { value: "ALL", label: "All" },
];

export const filterByStatus = <T extends { _status: EntityStatus }>(
  items: T[],
  filter: StatusFilter
): T[] => {
  if (filter === "ALL") return items;
  return items.filter((i) => i._status === filter);
};
